// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IActionButtonV1Schema } from '../action_button_v1/ActionButtonV1Schema';
import type { IActionButtonV2Schema } from '../action_button_v2/ActionButtonV2Schema';
import type { IActionButtonV3Schema } from '../action_button_v3/ActionButtonV3Schema';
import type { IMessageAssumptionsSchema } from '../check_message/MessageAssumptionsSchema';
import type { IBubbleSchema } from '../bubble/BubbleSchema';
import type { IMessageListFilesSchema } from '../file/MessageListFilesSchema';
import type { IOfferForClientSchema } from '../for_client/OfferForClientSchema';

export interface IMessageListItemV1Schema {
  /** Данные для кнопки в сообщении **/
  actionButton?: IActionButtonV1Schema;
  /** Пользователь может выбрать из предлагаемых действий/ответов в зависимости от того что написано в сообщение. **/
  actionButtons?: IActionButtonV2Schema[];
  /**
   *
   *     Пользователь может выбрать из предлагаемых действий/ответов в зависимости от того что написано в сообщение;
   *     Формат кнопок v3
   *
   */
  actionButtonsV3?: IActionButtonV3Schema[];
  /** Информация о различных предположениях/подозрениях по данному сообщению **/
  assumptions?: IMessageAssumptionsSchema;
  /** Дополнительные сообщения для пользователя, которые видит только он **/
  bubbles?: IBubbleSchema[];
  /** Отправлено мастер агентом **/
  byMasterAgent?: boolean;
  /** Идентификатор чата **/
  chatId?: string;
  /** Уникальный id коммуникации **/
  communicationId?: string;
  /** Таймстемп создания сообщения **/
  created?: number;
  /** Таймстемп создания сообщения(с точностью до ms) **/
  createdMs?: number;
  /** Все файлы, которые были отправлены в сообщении. Файлы присутствуют в сообщение, если type=text_and_files **/
  files?: IMessageListFilesSchema;
  /** Текст html **/
  htmlText?: string;
  /** Идентификатор сообщения **/
  messageId: string;
  /** Объявления прикреплённые к сообщению **/
  offers: IOfferForClientSchema[];
  /** Сообщение прочитано получателем **/
  read?: boolean;
  /** Текст сообщения **/
  text?: string;
  /** Тип сообщения **/
  type?: EType;
  /** Идентификатор сообщения с клиента **/
  uid?: string;
  /** Сообщение не прочитано текущим пользователем **/
  unread?: boolean;
  /** Идентификатор пользователя **/
  userId?: number;
}
export enum EType {
  /** Данные о входящем лиде **/
  'LeadInfo' = 'leadInfo',
  /** Сообщение-объявление **/
  'Offer' = 'offer',
  /**
   *
   *     Системное сообщение. Которое, к примеру, может возникать тогда,
   *     когда пользователь присоединился к чату или вышел из него.
   *
   */
  'SystemInfo' = 'systemInfo',
  /** Текстовое сообщение **/
  'Text' = 'text',
  /** Сообщение с прикрепленными файлами. Текст сообщения может отсутствовать. **/
  'TextAndFiles' = 'textAndFiles',
  /**
   *
   *     Используется только в случае когда сообщение представлено для чатов 1.0,
   *     и при этом у сообщения есть несколько вариантов ответов/действий
   *     или есть хоть один вариант ответа с типом ActionButtonV2Type.deeplink
   *
   */
  'TextWithActions' = 'textWithActions',
}
